import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { useTheme } from "@mui/material";
import LinearProgress from "@mui/material/LinearProgress";
import Link from "@mui/material/Link";

import { SUPPORT_EMAIL } from "@/config";
import { request } from "@/Api";
import { setToken, selectIsOrganizationInitialized } from "@/auth/authSlice";
import { setWelcomeTourOpen } from "@/nav/navSlice";
import { InitScreen } from "@/auth/StyledComponents";
import { MakeOSIcon } from "@/common/CommonComponents";

export default function Init() {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [error, setError] = useState(null);
    const isOrganizationInitialized = useSelector(
        selectIsOrganizationInitialized,
    );
    const timeoutRef = useRef(null);
    const checkCount = useRef(0);

    const checkIfStillInitializing = () => {
        request
            .post(`/refresh-token`, {})
            .then((response) => {
                dispatch(setToken(response.data));
                checkCount.current += 1;
                if (checkCount.current > 10) {
                    setError("Failed to set up account.");
                } else {
                    timeoutRef.current = setTimeout(
                        checkIfStillInitializing,
                        5000,
                    );
                }
            })
            .catch((e) => {
                setError("Failed to set up account.");
            });
    };

    useEffect(() => {
        if (isOrganizationInitialized) {
            clearTimeout(timeoutRef.current);
            dispatch(setWelcomeTourOpen(true));
            navigate("/dashboard");
        } else {
            timeoutRef.current = setTimeout(checkIfStillInitializing, 1000);
        }
    }, [isOrganizationInitialized]);

    return (
        <InitScreen backgroundColor={theme.palette.background.default}>
            <MakeOSIcon width="300" />

            {error ? (
                <>
                    <p style={{ marginTop: "48px" }}>{error}</p>
                    <p>
                        Please contact us at{" "}
                        <Link href={`mailto:${SUPPORT_EMAIL}`}>
                            {SUPPORT_EMAIL}
                        </Link>
                    </p>
                </>
            ) : (
                <>
                    <p style={{ width: "300px" }}>
                        <LinearProgress
                            color="primary"
                            sx={{ marginTop: "12px" }}
                        />
                    </p>
                    <p style={{ margin: "0" }}>Initializing account</p>
                </>
            )}
        </InitScreen>
    );
}
